"use strict";
export default (() => {
  const carousels = document.querySelectorAll("[data-swiper]");
  if (carousels.length === 0)
    return;
  carousels.forEach((value, index) => {
    var _a;
    let options, images;
    if (value.dataset.swiper !== void 0 && value.dataset.swiper !== "") {
      options = JSON.parse(value.dataset.swiper);
      images = (_a = options == null ? void 0 : options.thumbnails) == null ? void 0 : _a.images;
    }
    const swiper = new Swiper(value, options);
    if (options == null ? void 0 : options.controlSlider) {
      let controlledSliders = [];
      if (Array.isArray(options.controlSlider)) {
        controlledSliders = options.controlSlider.map(
          (selector) => document.querySelector(selector)
        );
      } else {
        controlledSliders.push(document.querySelector(options.controlSlider));
      }
      const swiperControlledInstances = controlledSliders.map(
        (controlledSlider) => {
          const controlledSliderOptions = (controlledSlider == null ? void 0 : controlledSlider.dataset.swiper) && JSON.parse(controlledSlider.dataset.swiper);
          return new Swiper(controlledSlider, controlledSliderOptions);
        }
      );
      swiper.controller.control = swiperControlledInstances;
    }
  });
})();
